import * as types from "./home.constant";

const defaultState = {lastTime:0,
    games:null  , error:null,
    banners:null, user:null  , isStandalone:false
    ,showForgetDialog:false ,  language:"en" , direction:"ltr" ,offers:null,
    categories:null , gameId:null
};



export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.HOME_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };

        case types.HOME_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
